/** Verze formátu projektového souboru — umožní budoucí migrace. */
export const PROJECT_FORMAT_VERSION = 1;
export function defaultViewSettings() {
    return {
        showNonKeyColumns: true,
        showColumnType: true,
        showNullable: true,
        showDefault: true,
        showComment: true,
        showCardinalityLabel: true,
    };
}
/**
 * „ER diagram pohled" (Epic 8, E8-US1, kap. 2 rozhodnutí) — vypne všech 5
 * sloupcových přepínačů, ale `showCardinalityLabel` NECHÁVÁ zapnutý:
 * kardinalita je právě to, čím se ER diagram definuje, takže bez ní by preset
 * byl protimluv. Presety tedy nejsou dokonale symetrické, a to záměrně.
 */
export function erDiagramViewSettings() {
    return {
        showNonKeyColumns: false,
        showColumnType: false,
        showNullable: false,
        showDefault: false,
        showComment: false,
        showCardinalityLabel: true,
    };
}
export function emptyCanvasMetadata() {
    return {
        viewSettings: defaultViewSettings(),
        tablePositions: {},
        tableColors: {},
        groups: [],
        notes: [],
        edgeRoutes: {},
    };
}
/** `null`, pokud uživatel není ani creator, ani editor (žádný vztah k projektu). */
export function getProjectRole(project, userId) {
    if (project.creatorId === userId)
        return 'creator';
    if (project.editorIds.includes(userId))
        return 'editor';
    return null;
}
//# sourceMappingURL=project.js.map